import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import styles from './AmbientStatement.module.css';

const AmbientStatement = ({ 
  bgImage, 
  text, 
  parallaxSpeed = 0.35, // no longer used for strict parallax, keeping prop for compatibility
  overlayOpacity = 0.6,
  textSize = 'large'
}) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"]
  });
  
  // Heavy animation parameters mapped to scroll
  const scaleBg = useTransform(scrollYProgress, [0, 0.4, 0.8], [1.5, 1, 1]); // Image starts huge and scales down to normal
  
  // Overlay gets slightly darker as it locks into place
  const currentOverlayOpacity = useTransform(scrollYProgress, [0.3, 0.5, 0.8], [overlayOpacity - 0.2, overlayOpacity, overlayOpacity + 0.1]);
  
  // Text starts massive and transparent, shrinking down and fading in
  const scaleText = useTransform(scrollYProgress, [0.3, 0.6, 0.9], [1.3, 1, 0.95]);
  const textOpacity = useTransform(scrollYProgress, [0.3, 0.5, 0.8, 1], [0, 1, 1, 0.5]);
  const textY = useTransform(scrollYProgress, [0.3, 0.6], [50, 0]);

  return (
    <div ref={ref} className={styles.scrollContainer}>
      <div className={styles.stickyViewport}>
        <motion.div 
          className={styles.bg}
          style={{ 
            backgroundImage: `url(${bgImage})`,
            scale: scaleBg,
            transformOrigin: "center center"
          }}
        />
        <motion.div 
          className={styles.overlay} 
          style={{ backgroundColor: "rgba(7, 8, 14, 1)", opacity: currentOverlayOpacity }}
        />
        
        <div className={styles.content}>
          <motion.h2 
            className={textSize === 'large' ? styles.textLarge : styles.textMedium}
            style={{ 
              scale: scaleText, 
              opacity: textOpacity,
              y: textY
            }}
          >
            {text}
          </motion.h2>
        </div>
      </div>
    </div>
  );
};

export default AmbientStatement;
